class ProductPurchaseForm extends HTMLElement {
  constructor() {
    super();
    this._boundCloseModal = this.closeModal.bind(this);
    this._boundHandleModalKeydown = this._handleModalKeydown.bind(this);
  }

  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    
    this.subBtn = this.querySelector('.js-add-subscription');
    this.onetimeBtn = this.querySelector('.js-add-onetime');
    this.modal = this.querySelector('#onetime-modal');

    if (this.subBtn) {
      this.subBtn.addEventListener('click', this._onSubscriptionClick.bind(this));
    }
    if (this.onetimeBtn) {
      this.onetimeBtn.addEventListener('click', this._onOnetimeClick.bind(this));
    }
    if (this.modal) {
      this.querySelectorAll('.js-onetime-modal-close').forEach((btn) => {
        btn.addEventListener('click', this._boundCloseModal);
      });
      this.modal.addEventListener('keydown', this._boundHandleModalKeydown);

      const modalBuyOnetime = this.modal.querySelector('.js-modal-buy-onetime');
      if (modalBuyOnetime) {
        modalBuyOnetime.addEventListener('click', this._onModalBuyOnetimeClick.bind(this));
      }
      const modalAddSubscription = this.modal.querySelector('.js-modal-add-subscription');
      if (modalAddSubscription) {
        modalAddSubscription.addEventListener('click', this._onModalAddSubscriptionClick.bind(this));
      }
    }
  }

  disconnectedCallback() {
    if (this.modal) {
      this.querySelectorAll('.js-onetime-modal-close').forEach((btn) => {
        btn.removeEventListener('click', this._boundCloseModal);
      });
      this.modal.removeEventListener('keydown', this._boundHandleModalKeydown);
    }
  }

  _getSectionsToRender() {
    const cartContent = document.getElementById('cart-drawer__content');
    if (!cartContent || !cartContent.dataset.id) return [];
    return [
      { id: 'cart-drawer__content', section: cartContent.dataset.id, selector: '.cart-drawer__content' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }

  addToCart(variantId, sellingPlanId) {
    if (this._adding) return;
    this._adding = true;
    const cartDrawer = document.querySelector('cart-drawer');
    const sections = this._getSectionsToRender();
    const body = { id: variantId, quantity: 1, sections: sections.map((s) => s.section) };
    if (sellingPlanId) body.selling_plan = sellingPlanId;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.description || data.message) {
          return Promise.reject(new Error(data.description || data.message));
        }
        return data;
      })
      .then((data) => {
        if (data.sections) {
          sections.forEach((s) => {
            const el = document.getElementById(s.id);
            if (!el) return;
            const target = el.querySelector(s.selector) || el;
            const parsed = new DOMParser().parseFromString(data.sections[s.section], 'text/html');
            const inner = parsed.querySelector(s.selector);
            if (inner) target.innerHTML = inner.innerHTML;
          });
        }
        if (cartDrawer) cartDrawer.open();
      })
      .finally(() => {
        this._adding = false;
      });
  }

  _setLoading(btn, loading) {
    if (!btn) return;
    btn.disabled = loading;
    btn.classList.toggle('loading', loading);
  }

  openModal() {
    if (!this.modal) return;
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const firstFocus = this.modal.querySelector('.js-modal-buy-onetime');
    if (firstFocus) firstFocus.focus();
  }

  closeModal() {
    if (!this.modal) return;
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (this.onetimeBtn) this.onetimeBtn.focus();
  }

  _handleModalKeydown(e) {
    if (e.key === 'Escape' && this.modal.getAttribute('aria-hidden') === 'false') {
      this.closeModal();
    }
  }

  _onSubscriptionClick() {
    const vid = this.subBtn.dataset.variantId;
    const plan =
      this.subBtn.dataset.sellingPlanId && this.subBtn.dataset.sellingPlanId !== ''
        ? this.subBtn.dataset.sellingPlanId
        : null;
    this._setLoading(this.subBtn, true);
    this.addToCart(vid, plan)
      .catch(() => {})
      .finally(() => this._setLoading(this.subBtn, false));
  }

  _onOnetimeClick() {
    if (this.modal) {
      this.openModal();
    } else {
      const vid = this.onetimeBtn.dataset.variantId;
      this._setLoading(this.onetimeBtn, true);
      this.addToCart(vid, null)
        .catch(() => {})
        .finally(() => this._setLoading(this.onetimeBtn, false));
    }
  }

  _onModalBuyOnetimeClick() {
    const btn = this.modal.querySelector('.js-modal-buy-onetime');
    const vid = btn.dataset.variantId;
    this._setLoading(btn, true);
    this.addToCart(vid, null)
      .catch(() => {})
      .finally(() => {
        this._setLoading(btn, false);
        this.closeModal();
      });
  }

  _onModalAddSubscriptionClick() {
    const btn = this.modal.querySelector('.js-modal-add-subscription');
    const vid = btn.dataset.variantId;
    const plan =
      btn.dataset.sellingPlanId && btn.dataset.sellingPlanId !== '' ? btn.dataset.sellingPlanId : null;
    this._setLoading(btn, true);
    this.addToCart(vid, plan)
      .catch(() => {})
      .finally(() => {
        this._setLoading(btn, false);
        this.closeModal();
      });
  }
}

customElements.define('product-purchase-form', ProductPurchaseForm);
